import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import Cropper, { Area } from 'react-easy-crop';
import { theme } from '../../../theme';
import { relative } from 'path';

// Define and export CropPanelProps interface
export interface CropPanelProps {
  imageSrc: string | null;
  crop: { x: number; y: number };
  setCrop: React.Dispatch<React.SetStateAction<{ x: number; y: number }>>;
  zoom: number;
  setZoom: React.Dispatch<React.SetStateAction<number>>;
  onCropComplete: (croppedArea: Area, croppedAreaPixels: Area) => void;
  onSave: () => void;
  onCancel: () => void;
}

const CropPanel: React.FC<CropPanelProps> = ({
  imageSrc,
  crop,
  setCrop,
  zoom,
  setZoom,
  onCropComplete,
  onSave,
  onCancel,
}) => (
  <Box
    sx={{
      width: '100%',
      height: '70vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      px: 2,
      py: 3,
    }}
  >
    {/* Title */}
    <Typography variant="h6" sx={{ fontWeight: 600 }}>
      Crop Image
    </Typography>

    {/* Optional delete icon (uncomment if needed) */}
    {/* 
  <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
    <i
      className="fa-solid fa-trash"
      style={{ cursor: 'pointer', color: theme.palette.primary.main }}
      onClick={onCancel}
    />
  </Box>
  */}

    {/* Cropper */}
    {imageSrc && (
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          my: 2,
        }}
      >
        <Box sx={{ width: 280, height: 280, position: 'relative' }}>
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            aspect={1}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
            style={{ containerStyle: { height: '280px', width: '280px' } }}
          />
        </Box>
      </Box>
    )}

    {/* Action Buttons */}
    <Box sx={{ display: 'flex', gap: 2 }}>
      <Button onClick={onCancel} variant="outlined" sx={{ flex: 1 }}>
        Cancel
      </Button>
      <Button onClick={onSave} variant="contained" sx={{ flex: 1 }}>
        Set
      </Button>
    </Box>
  </Box>

);

export default CropPanel;
